import { Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';
import React from 'react';

import '../../styles/common.scss';

const DEFAULT_ALERT_DESCRIPTION =
  'An unexpected error occurred. Please contact finley for support.';

export const InfoAlertWithDescription = ({
  description,
}: {
  description?: string;
}) => {
  return (
    <Alert status="info">
      <AlertIcon />
      <AlertDescription>
        {description ?? DEFAULT_ALERT_DESCRIPTION}
      </AlertDescription>
    </Alert>
  );
};
